/**
 * Coercion for quote-cart values that end up in innerHTML. The cart lives in localStorage, which
 * any script on the origin (or a user) can edit, so a line's id/qty is untrusted: quoteStore only
 * checks `typeof id === "number"`, which lets NaN-free oddities like 1e21 or 3.5 through, and a
 * non-number qty would be printed as-is.
 */
const MAX_QTY = 999;

/** A positive safe integer id, or 0 (which matches no product). */
export function safeLineId(value: unknown): number {
    const n = typeof value === 'number' ? value : Number(value);
    return Number.isSafeInteger(n) && n > 0 ? n : 0;
}

/** A whole quantity between 1 and 999. */
export function safeQty(value: unknown): number {
    const n = Math.floor(Number(value));
    if (!Number.isFinite(n) || n < 1) return 1;
    return Math.min(n, MAX_QTY);
}
